export default __webpack_public_path__ + "static/media/huma-evaremixes-cover.575eb7c3.jpg";